// web/shims/LottieShim.tsx
// Shim for lottie-react-native on web using lottie-react (React 19 compatible)

import React from 'react';
import Lottie from 'lottie-react';
import type { CSSProperties } from 'react';
import type { ViewStyle } from 'react-native';

interface LottieViewProps {
  source: object;
  autoPlay?: boolean;
  loop?: boolean;
  speed?: number;
  style?: ViewStyle;
  resizeMode?: 'cover' | 'contain' | 'center';
  onAnimationFinish?: () => void;
}

const LottieView = React.forwardRef<unknown, LottieViewProps>(
  (
    {
      source,
      autoPlay = true,
      loop = true,
      speed = 1,
      style,
      resizeMode = 'contain',
      onAnimationFinish,
    },
    ref,
  ) => {
    const lottieRef = React.useRef<any>(null);

    React.useImperativeHandle(ref, () => ({
      play: () => lottieRef.current?.play(),
      pause: () => lottieRef.current?.pause(),
      reset: () => lottieRef.current?.goToAndStop(0),
    }));

    // Map resizeMode to object-fit
    const objectFit: CSSProperties['objectFit'] =
      resizeMode === 'cover'
        ? 'cover'
        : resizeMode === 'center'
          ? 'none'
          : 'contain';

    // Convert RN style to web style
    const webStyle: CSSProperties = {
      ...(style as CSSProperties),
      objectFit,
    };

    return (
      <Lottie
        lottieRef={lottieRef}
        animationData={source}
        autoplay={autoPlay}
        loop={loop}
        style={webStyle}
        onComplete={onAnimationFinish}
      />
    );
  },
);

LottieView.displayName = 'LottieView';

export default LottieView;
